import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { FormItemDateRange, getDatePickerDate } from '@tesla/design-system-react';
import { useField } from 'informed';
import { getLocalContextualDateRange, getLocalStandardDate } from '@tesla/design-system';
import { isValidDate } from './utils/isValidDate.js';

var _excluded = ["dateType", "label", "feedback", "formatDateRange", "helper", "id", "locale", "tooltip", "placeholder", "readonly", "singleInputProps"];

/**
 * Renders a date range input
 *
 */
function DateRangeInput(props) {
  var _useField = useField(props),
    fieldApi = _useField.fieldApi,
    fieldState = _useField.fieldState,
    render = _useField.render,
    userProps = _useField.userProps,
    ref = _useField.ref;
  var dateType = userProps.dateType,
    label = userProps.label,
    feedback = userProps.feedback,
    userFormatDateRange = userProps.formatDateRange,
    helper = userProps.helper,
    id = userProps.id,
    _userProps$locale = userProps.locale,
    locale = _userProps$locale === void 0 ? 'en-US' : _userProps$locale;
    userProps.tooltip;
    var userPlaceholder = userProps.placeholder,
    readonly = userProps.readonly,
    _userProps$singleInpu = userProps.singleInputProps,
    singleInputProps = _userProps$singleInpu === void 0 ? {} : _userProps$singleInpu,
    passthroughProps = _objectWithoutProperties(userProps, _excluded);
  var showError = fieldState.showError,
    error = fieldState.error,
    value = fieldState.value;
  var setValue = fieldApi.setValue,
    setTouched = fieldApi.setTouched;
  var dateFormatter = userFormatDateRange ? userFormatDateRange : function (start, end) {
    return end ? getLocalContextualDateRange(getDatePickerDate(start, dateType), getDatePickerDate(end, dateType), locale) : getLocalStandardDate(getDatePickerDate(start, dateType), locale);
  };
  var today = new Date();
  var todayPlusSeven = new Date(new Date().setDate(today.getDate() + 7));
  var placeholder = userPlaceholder !== null && userPlaceholder !== void 0 ? userPlaceholder : dateFormatter(dateType === 'string' ? today.toISOString().slice(0, 10) : today, dateType === 'string' ? todayPlusSeven.toISOString().slice(0, 10) : todayPlusSeven, locale);
  return render( /*#__PURE__*/React.createElement(FormItemDateRange, _extends({}, passthroughProps, {
    dateType: dateType,
    error: showError,
    feedback: error !== null && error !== void 0 ? error : feedback,
    helper: helper,
    id: id,
    locale: locale,
    onBlur: function onBlur() {
      setTouched(true);
    },
    singleInput: true,
    singleInputRef: ref,
    singleInputInputProps: _objectSpread2(_objectSpread2({}, singleInputProps), {}, {
      placeholder: placeholder,
      readOnly: readonly,
      value: dateType == 'string' && value !== null && value !== void 0 && value.start || isValidDate(value === null || value === void 0 ? void 0 : value.start) ? dateFormatter(value.start, value.end, locale) : ''
    }),
    singleInputLabelProps: {
      children: label
    },
    start: value === null || value === void 0 ? void 0 : value.start,
    end: value === null || value === void 0 ? void 0 : value.end,
    onDateChange: function onDateChange(v) {
      setValue(v, {});
    }
  })));
}

export { DateRangeInput };
